// Ported from `app/page.tsx` in `git@git.fugl.dev:sks/yominoki.git` @
// `515ce239`.
//
// The form is unchanged and stays a PLAIN HTML POST to /api/atproto/login,
// not a fetch. The endpoint answers 303 to the reader's PDS, and letting the
// browser follow that navigation itself is both simpler and the reason
// sign-in works before this bundle has finished loading.
//
// The `redirect("/drill")` this page opened with is a `<Navigate replace>`:
// same effect, and `replace` keeps the sign-in URL out of history so Back
// from the drill does not land on a page that immediately forwards again.

import { Navigate } from "react-router";
import { Button } from "@bindery/ui/components/ui/button";
import { Input } from "@bindery/ui/components/ui/input";
import { useSession } from "../hooks/use-session";

export function LandingPage() {
  const session = useSession();

  // Not signed out — just not answered yet. Rendering the sign-in form here
  // would show it for a beat to a reader who is already signed in.
  if (session.status === "unknown") return null;
  if (session.status === "signed-in") return <Navigate to="/drill" replace />;

  return (
    <div className="flex min-h-svh items-center justify-center p-6">
      <div className="flex w-full max-w-sm flex-col gap-4">
        <div className="space-y-1">
          <h1 className="font-jp-display text-xl font-medium">Yominoki</h1>
          <p className="text-muted-foreground text-sm">
            Sign in with your Bluesky handle to start reading.
          </p>
        </div>
        <form
          action="/api/atproto/login"
          method="post"
          className="flex flex-col gap-2"
        >
          <Input
            name="handle"
            type="text"
            placeholder="alice.bsky.social"
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            required
          />
          <Button type="submit">Continue</Button>
        </form>
      </div>
    </div>
  );
}
